import type { ComponentAITemplate } from 'types/story';

export const texts = {
	title: 'AI Template Configuration',
	description: 'Configure AI template for this component. This will be used during content generation.',
	uniqueKey: {
		label: 'Unique identifier',
		hint: 'Used to reference this element in AI prompts (e.g., questionTitle, answer, image)',
		hintWithExisting: (existing: string[]) =>
			`Used to reference this element in AI prompts. Existing: ${existing.join(', ')}`,
		errorDuplicate: 'This key already exists. Please choose a unique identifier.',
	},
	type: {
		label: 'Type',
		hint: 'Select the type of content this prompt will generate',
		hintCollection:
			'Collection creates multiple instances of child elements. Example: "Generate 4 answers" creates 4 answer components.',
		options: {
			text: 'Text',
			image: 'Image',
			flag: 'Flag',
			group: 'Collection',
		},
	},
	prompt: {
		label: 'Prompt',
		placeholder: 'Enter AI prompt for content generation...',
		hint: 'Describe what content should be generated for this component',
	},
	groupRef: {
		label: 'Group Reference',
		placeholder: 'e.g., answers (reference to parent group)',
		hint: 'Reference to the parent group this element belongs to (optional)',
	},
	buttons: {
		cancel: 'Cancel',
		clear: 'Clear',
		save: 'Save',
	},
};

export const PROMPT_TYPE_OPTIONS: Array<{ label: string; value: ComponentAITemplate['type'] }> = [
	{ label: texts.type.options.text, value: 'text' },
	{ label: texts.type.options.image, value: 'image' },
	{ label: texts.type.options.flag, value: 'flag' },
	{ label: texts.type.options.group, value: 'group' },
];

export const PREDEFINED_KEY_OPTIONS = [
	{ value: 'questionTitle', label: 'Question Title' },
	{ value: 'questionText', label: 'Question Text' },
	{ value: 'answer', label: 'Answer Option' },
	{ value: 'answerText', label: 'Answer Text' },
	{ value: 'answerImage', label: 'Answer Image' },
	{ value: 'text', label: 'Text' },
	{ value: 'image', label: 'Image' },
	{ value: 'callToAction', label: 'Call to Action' },
	{ value: 'cardBackground', label: 'Card Background' },
];
